import { computed, reactive, ref, watch } from "vue";
import { ElMessage } from "element-plus";
import store from "@/store";

export default () => {
  const promptParams = reactive({
    // 绘图比例
    ratio: "",
    // 用户输入
    text: "",
    // 参考提示词
    keywords: "",
  });

  // 监听keywords变化
  watch(
    () => promptParams.keywords,
    (n) => {
      promptParams.text += ` ${n}`;
    }
  );

  // 最终提交的prompt结构由 上传的图片 用户输入(包括提示词) 比例组成
  const submitPrompt = computed(() => {
    const { ratio, text } = promptParams;
    // 按顺序放入img text
    const struct = [];
    struct.push(text);
    // 最后加入ratio
    if (ratio) {
      struct.push(`--aspect ${ratio}`);
    }
    if (!text.trim()) return "";
    // 用空格隔空
    return struct.join(" ");
  });

  const cleanText = () => {
    promptParams.text = "";
  };

  const beautifulLoading = ref(false);
  const writing = ref(false);
  // 美化关键词（逐字）
  async function beautifyText(onDataCallback) {
    beautifulLoading.value = true;
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    const res = await fetch("/web.php/chat/sendText_tishichi", {
      method: "POST",
      body: JSON.stringify({
        message: promptParams.text,
      }),
      headers,
    }).finally(() => {
      beautifulLoading.value = false;
    });
    if (res.ok) {
      writing.value = true;
      const reader = res.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let done = false;
      let curAiMsg = "";
      promptParams.text = "";
      while (!done) {
        const { value, done: readerDone } = await reader.read();
        if (value) {
          let char = decoder.decode(value, { stream: true }); // 注意这里添加了stream参数
          if (char === "\n" && curAiMsg.endsWith("\n")) {
            continue;
          }
          if (char.includes('"errno":408')) {
            console.log("char", char);
            const d = JSON.parse(char);
            ElMessage.error(d.message);
            return;
          }
          if (char.includes('"errno":403')) {
            console.log("char", char);
            const d = JSON.parse(char);
            ElMessage.error(d.message);
            store.commit("SET_SHOW_LOGIN", true);
            return;
          }
          if (char) {
            promptParams.text += char;
            onDataCallback && onDataCallback();
          }
        }
        done = readerDone;
      }
    }
    writing.value = false;
  }
  return {
    submitPrompt,
    promptParams,
    writing,
    beautifulLoading,
    beautifyText,
    cleanText,
  };
};
